import { Component, Prop, Vue } from 'vue-property-decorator'
import { SubportionAnalysisResultResponse } from '@/modules/diagnosisModule/services/diagnosis-portion-service.dto'

@Component
export default class SubportionAnalysisSidePanel extends Vue {
    @Prop({ type: Array, required: true, default: () => [] }) subportionAnalysisResult!: SubportionAnalysisResultResponse[]
    @Prop({ type: String, default: '-' }) subportionLabel!: string

    getDeviceLabel(analysisResultItem: SubportionAnalysisResultResponse): string {
        return `${analysisResultItem.device.device} - ${analysisResultItem.device.model} - ${analysisResultItem.device.type.translatedName}`
    }

    onCloseSidePanelButtonClick() {
        this.$emit('close-side-panel')
    }
}
